// src/components/FooterSection.js
import "./footerSection.css";
import React, { forwardRef } from 'react';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const FooterSection = forwardRef((props, ref) => {
  return (
    <footer ref={ref} className="footer">
      <div className="footer-left">
        {/*<h2 className="footer-left-title">Saffron House</h2>*/}
        <img className="footer-left-title" src="/images/saffronhouselogo.png" alt="Description of the image" />
        <p className="footer-left-copyright">
          2024 Saffron House. All Rights Reserved. <br></br> <br></br>
          Developed By -  <br></br>ARVI Technologies And Consultation
        </p>
      </div>
      <div className="footer-divider-wrapper">
        <div className="footer-divider"></div>
      </div>
      <div className="footer-right">
        <div className="footer-cta">
          <h3 className="footer-cta-title">Let's talk about Interiors!</h3>
          <p className="footer-cta-subtitle">
            We’re Here to Turn Your Interior Ideas into Reality
          </p>
          <div>
            <button className="footer-button">Contact Us
              <ArrowOutwardIcon className="footer-button-icon"></ArrowOutwardIcon>
            </button>
          </div>
        </div>
        <div className="footer-cta">
          <h3 className="footer-cta-title">Get to know us close!</h3>
          <p className="footer-cta-subtitle">
            See Our Latest Designs and Behind-the-Scenes Moments
          </p>
          <div>
            <button className="footer-button"
            
            onClick={() => window.open('https://www.instagram.com/_saffronhouse/', '_blank')}

            >Follow Us on Instagram
              <ArrowOutwardIcon className="footer-button-icon"></ArrowOutwardIcon>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
});

export default FooterSection;